<script setup>
import { getCampaignData } from '../../../utilities/investment-process/useCampaign'
import InterestPaymentTypeSelect from '../interestPayment/InterestPaymentTypeSelect.vue'
import InvestmentAmountSelect from '../investmentAmount/investmentAmountSelect.vue'
import IncentivesSelect from '../incentives/IncentivesSelect.vue'
import { onMounted } from 'vue'
import { trackAnalyticsInvestmentProcessStep1 } from '../../../utilities/useTracking'
import { useInvestmentProcessDataState } from '../../../utilities/investment-process/useInvestmentProcess'
import { storeToRefs } from 'pinia'

const useInvestmentStore = useInvestmentProcessDataState()
const { incentiveUid, investmentAmount } = storeToRefs(useInvestmentStore)
const campaignData = getCampaignData()

onMounted(() => {
    trackAnalyticsInvestmentProcessStep1()
    const urlParams = new URLSearchParams(window.location.search)
    const iParam = urlParams.get('i')
    if (iParam) {
        const incentive = campaignData.assets_incentives.find((incentive) => incentive.asset_inc_uid === iParam)
        if (incentive) {
            incentiveUid.value = iParam
            investmentAmount.value = incentive.incentives_amount
        }
    }
})
</script>

<template>
    <div class="px-6 py-6">
        <InterestPaymentTypeSelect
            v-if="campaignData.asset_data.needs_contract_type_selection"></InterestPaymentTypeSelect>
        <InvestmentAmountSelect></InvestmentAmountSelect>
        <IncentivesSelect v-if="campaignData.assets_incentives.length > 0"></IncentivesSelect>
    </div>
</template>

<style scoped></style>
